<template>
  <div :id="id + '_wrapper'" >
  

   <select class="form-select" v-model="selectedObject" :multiple="multiple" :id="id" :track-by="trackBy" :searchable="searchable" :aria-labelledby="id+'_label'" @change="onSelected" :placeholder="placeholder">
      <option v-for="item in items" :value="item.value" :key="item.value">{{ item.name}}</option>
    </select>



  </div>
</template>

<script>

export default {
  name: "IcSystemSelect",
  props: {
    id: {
      type: String,
      required: true
    },
    value: {
      required: true
    },
    values: {
      type: Array,
      required: true
    },
    multiple: {
      type: Boolean,
      default: false
    },
    placeholder: {
      type: String,
      default: "..."
    },
    allowEmpty: {
      type: Boolean,
      default: true
    },
    searchable: {
      type: Boolean,
      default: true
    },    
    v: {
      type: Object
    },
    forceSingleSelect: {
      type: Array,
      default: () => ["na"]
    },
    trackBy: {
      type: String,
      default: "value"
    },
    asObject: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      items: [],
      selectedObjects: [],
      selectedObject: null,
      fields : { text: 'name', value: 'value' }
    };
  },
  watch: {
    value: function(newValue, oldValue) {
      this.selectedObjects = this.valuesToObjects(newValue);
    },
    values: function(newValue, oldValue) {
      if (newValue && newValue !== oldValue) {
        this.items = newValue;
        this.selectedObjects = this.valuesToObjects(this.value);
      }
    }
  },
  beforeMount() {
    this.items = this.prepareValues(this.values);
    console.log(this.items);
  },
  mounted() {
    this.selectedObjects = this.valuesToObjects(this.value);
  },
  methods: {
    onSelected(value, id) {
      let values = null;

        if (this.selectedObject) {
          values = this.asObject
            ? this.selectedObject
            : this.selectedObject;
        }

      

      this.$emit("input", values);
      this.$emit("update:select", this.selectedObject);
      if (this.v) {
        this.v.$touch();
      }
    },
    valuesToObjects(values) {
      let newValues = null;
      if (this.multiple) {
        newValues = this.items.filter(item => {
          return values.indexOf(item[this.trackBy]) != -1;
        });
      } else {
        newValues = this.items.find(item => {
          return values === item[this.trackBy];
        });
      }
      return newValues;
    },
    prepareValues(values) {
      if (values && values.length) {
        let val = [];
        values.forEach(item => {
          if (typeof item !== "object") {
            val.push({ value: item, label: item, name: item });
          } else {
            item.label = item.name;
            val.push(item);
          }
        });
        ////console.log(val);
        return val;
      }
    }
  },
  components: {
    
  }
};
</script>

<style lang="scss">


</style>
